import { useSelector } from 'react-redux';

import { BankPartnersBlock } from 'shared/components/BankPartnersBlock';
import { selectBankPartners } from 'shared/selectors/dictionaries/selectBankPartners';

export const BankPartnersBlockContainer = () => {
  const bankPartners = useSelector(selectBankPartners);

  if (bankPartners.length === 0) {
    return null;
  }

  return <BankPartnersBlock bankPartners={bankPartners} />;
};
